export enum DayFilterTypes {
    Leave = 0,
    LeaveEndOfPeriod = 1,
    LeaveInPeriod = 2,
    Labor = 3,
    LaborEndOfPeriod = 4,
    LaborInPeriod = 5,
    LeaveCommunicationGap = 6
}
